import { render } from "./SelectTickets.vue?vue&type=template&id=2f6b1ab8&scoped=true"
import script from "./SelectTickets.vue?vue&type=script&lang=js"
export * from "./SelectTickets.vue?vue&type=script&lang=js"

import "./SelectTickets.vue?vue&type=style&index=0&id=2f6b1ab8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6b1ab8"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QSpinner,QList,QItem,QItemSection,QTooltip,QBtn});
